/* eslint-disable indent */
// Utility to access notistack snackbar outside React components
let enqueueSnackbarRef = null;

export const setSnackbarEnqueue = (enqueueFn) => {
  enqueueSnackbarRef = enqueueFn;
};

export const showSnackbar = (message, options = {}) => {
  if (enqueueSnackbarRef) {
    return enqueueSnackbarRef(message, {
      variant: 'error',
      ...options,
    });
  }
  // Fallback to console if snackbar is not initialized
  console.error('Snackbar not initialized:', message);
  return null;
};
